import type { ListerImage } from "../../../lib/api";

export default function ImagePicker({ images, selected, onChange }: { images: ListerImage[]; selected: string[]; onChange: (urls: string[]) => void }) {
  const toggle = (url: string) => onChange(selected.includes(url) ? selected.filter((u) => u !== url) : [...selected, url]);
  const move = (url: string, dir: -1 | 1) => {
    const i = selected.indexOf(url); const j = i + dir;
    if (i < 0 || j < 0 || j >= selected.length) return;
    const next = [...selected]; [next[i], next[j]] = [next[j]!, next[i]!]; onChange(next);
  };
  const ordered = [...selected.map((u) => images.find((i) => i.url === u)).filter((x): x is ListerImage => Boolean(x)), ...images.filter((i) => !selected.includes(i.url))];
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
      {ordered.map((img) => {
        const on = selected.includes(img.url); const pos = selected.indexOf(img.url);
        const low = Math.max(img.width ?? 0, img.height ?? 0) < 1000;
        return (
          <div key={img.url} className={`relative rounded overflow-hidden border ${on ? "border-green-500" : "border-zinc-800 opacity-60"}`}>
            <button aria-label={`toggle ${img.url}`} onClick={() => toggle(img.url)} className="block w-full aspect-square bg-zinc-900">
              {img.served_url ? <img src={img.served_url} alt="" className="w-full h-full object-contain" loading="lazy" /> : <span className="text-xs text-zinc-500">no file</span>}
            </button>
            <div className="absolute top-1 left-1 text-[10px] bg-black/70 px-1 rounded">{on ? `#${pos + 1}` : "off"} · {img.width ?? "?"}×{img.height ?? "?"}{low && <span className="text-yellow-300"> low res</span>}</div>
            {on && (
              <div className="absolute bottom-1 right-1 flex gap-1">
                <button aria-label={`move ${img.url} earlier`} onClick={() => move(img.url, -1)} className="bg-black/70 px-2 py-1 rounded text-xs">◀</button>
                <button aria-label={`move ${img.url} later`} onClick={() => move(img.url, 1)} className="bg-black/70 px-2 py-1 rounded text-xs">▶</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
